var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.url) ? _c('polaris-unstyled-link', {
    staticClass: "Polaris-ActionList__Item",
    attrs: {
      "url": _vm.url
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    }
  }, [(_vm.icon || _vm.image) ? [_c('div', {
    staticClass: "Polaris-ActionList__Content"
  }, [_c('div', {
    staticClass: "Polaris-ActionList__Image",
    style: ({
      backgroundImage: _vm.icon ? null : 'url(' + _vm.image + ')'
    }),
    attrs: {
      "role": "presentation"
    }
  }, [(_vm.icon) ? _c('polaris-icon', {
    attrs: {
      "source": _vm.icon
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-ActionList__Text"
  }, [_vm._t("default", [_vm._t("content", [_vm._v(_vm._s(_vm.content))])])], 2)])] : [_vm._v("\n            " + _vm._s(_vm.content) + "\n        ")]], 2) : _vm._e(), _vm._v(" "), (!_vm.url) ? _c('button', {
    class: _vm.classes,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    }
  }, [(_vm.icon || _vm.image) ? [_c('div', {
    staticClass: "Polaris-ActionList__Content"
  }, [_c('div', {
    staticClass: "Polaris-ActionList__Image",
    style: ({
      backgroundImage: _vm.icon ? null : 'url(' + _vm.image + ')'
    }),
    attrs: {
      "role": "presentation"
    }
  }, [(_vm.icon) ? _c('polaris-icon', {
    attrs: {
      "source": _vm.icon
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "Polaris-ActionList__Text"
  }, [_vm._t("default", [_vm._t("content", [_vm._v(_vm._s(_vm.content))])])], 2)])] : [_vm._t("default", [_vm._t("content", [_vm._v(_vm._s(_vm.content))])])]], 2) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dc44046", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc44046","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisActionListItem.vue
// module id = 143
// module chunks = 0